import React, { Component } from 'react'
import moment from 'moment'
import { withRouter } from 'react-router-dom'

import { Popup, Icon, Table, Button } from 'semantic-ui-react'

class DelivereeRow extends Component {
  viewUserOrders = () => {
    const { data, history, fireKey } = this.props

    history.push({
      pathname: `/customers/${data.phone}/order`,
      state: { uid: fireKey, createdAt: data.created_at },
    })
  }

  renderBlockDescription() {
    const { data } = this.props

    if (data.has_blocked) {
      if (typeof data.has_blocked === 'object') {
        return (
          <div>
            <h4>{data.has_blocked.title || 'Untitled'}</h4>
            <p>{data.has_blocked.description || 'No description'}</p>
          </div>
        )
      }
      return data.has_blocked.length > 0 ? data.has_blocked : 'No description'
    }

    return 'No description'
  }

  render() {
    const { id, fireKey, data, blockingToggle } = this.props

    const {
      phone,
      loggedUUID,
      family_name: famName,
      first_name: fName,
      last_session: session,
      created_at: createdAt,
    } = data
    const name = `${famName} ${fName}`
    const isBlocked = data.has_blocked || false

    return (
      <Table.Row>
        <Table.Cell>
          <strong>{id}</strong>
        </Table.Cell>
        <Table.Cell>
          <Popup
            style={{ maxWidth: 400 }}
            trigger={<strong>{name}</strong>}
            content={`UID: ${fireKey}`}
            on="click"
            hideOnScroll
          />
        </Table.Cell>
        <Table.Cell textAlign="center">
          <div style={{ marginBottom: 3 }}>
            {loggedUUID && (
              <Popup
                style={{ maxWidth: 600 }}
                trigger={
                  <Icon
                    size="large"
                    name={loggedUUID.includes('-') ? 'apple' : 'android'}
                    color={loggedUUID.includes('-') ? 'grey' : 'green'}
                  />
                }
                content={`UUID: ${loggedUUID}`}
                on="click"
                hideOnScroll
              />
            )}
          </div>
          {phone}
        </Table.Cell>
        <Table.Cell textAlign="center"> {session ? moment(session).fromNow() : ''} </Table.Cell>
        <Table.Cell textAlign="center">
          {createdAt && moment(createdAt).format('DD-MM-YYYY HH:mma')}
        </Table.Cell>
        <Table.Cell textAlign="center">
          <Button size="small" onClick={() => this.viewUserOrders()}>
            View Orders
          </Button>
          {isBlocked ? (
            <Popup
              trigger={
                <Button size="small" onClick={() => blockingToggle(isBlocked)}>
                  Unblock this user
                </Button>
              }
              content={this.renderBlockDescription()}
              hideOnScroll
            />
          ) : (
            <Button size="small" onClick={() => blockingToggle(isBlocked)}>
              Block this user
            </Button>
          )}
        </Table.Cell>
      </Table.Row>
    )
  }
}

export default withRouter(DelivereeRow)



// WEBPACK FOOTER //
// ./src/components/deliverees/row.js